import { ElementRef, EventEmitter, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { InfluencerPost } from '../../../../../models/influencer';
import { InfluencerService } from '../../../../services/influencer/influencer.service';
import { UserService } from '../../../../services/user.service';
import { NumberUtils } from '../../../../utils/number.utils';
var InfluencerOverviewPostContentComponent = /** @class */ (function () {
    function InfluencerOverviewPostContentComponent(router, influencerService, _ngZone, userService) {
        this.router = router;
        this.influencerService = influencerService;
        this._ngZone = _ngZone;
        this.userService = userService;
        this.displayMode = 'desktop';
        this.selectedPost = new EventEmitter();
        this.closePopupCardHover = new EventEmitter();
    }
    InfluencerOverviewPostContentComponent.prototype.ngOnInit = function () {
        this.currentInfluencer = this.userService.getInfluencerInfo();
    };
    InfluencerOverviewPostContentComponent.prototype.roundNumber = function (numb) {
        return Math.round(numb);
    };
    InfluencerOverviewPostContentComponent.prototype.getPlatformIcon = function (id) {
        return this.influencerService.getPlatformIconById(id);
    };
    InfluencerOverviewPostContentComponent.prototype.addToPreviewed = function (item) {
        this.selectedPost.emit(item);
    };
    InfluencerOverviewPostContentComponent.prototype.getTitle = function (fullTitle) {
        if (!fullTitle) {
            return '';
        }
        return fullTitle.slice(0, 199);
    };
    InfluencerOverviewPostContentComponent.prototype.getMediaLink = function (post) {
        if (post.isVideo) {
            return post.isStory ? post.url : post.videoUrl;
        }
        else {
            return post.imageUrl;
        }
    };
    InfluencerOverviewPostContentComponent.prototype.getPostDetailLink = function (post) {
        return this.currentInfluencer ? "/dashboard/post/" + post.urlHash : '/post/';
    };
    InfluencerOverviewPostContentComponent.prototype.getPostParams = function (post) {
        return this.currentInfluencer ? {} : {
            influencerId: post.blog_id,
            urlHash: post.urlHash,
            fullUrl: post.url,
            relativePath: post.relativepath,
            influencerGroupId: this.influencerGroupId,
            activeAccount: this.activeAccount,
            hideBackButton: true
        };
    };
    InfluencerOverviewPostContentComponent.prototype.openPostPage = function (post) {
        if (!post && post.completed) {
            return;
        }
        var currentInfluencer = this.userService.getInfluencerInfo();
        // new influencer platform version
        if (currentInfluencer) {
            return this.router.navigate(['dashboard', 'post', this.item.urlHash]);
        }
        else {
            return this.router.navigate(['post'], { queryParams: {
                    influencerId: this.item.blog_id,
                    urlHash: this.item.urlHash,
                    fullUrl: this.item.url,
                    relativePath: this.item.relativepath,
                    activeAccount: this.activeAccount,
                    hideBackButton: true
                } });
        }
    };
    Object.defineProperty(InfluencerOverviewPostContentComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerOverviewPostContentComponent.prototype, "reach", {
        get: function () {
            if (this.item.isStory && !this.item.completed) {
                return '-';
            }
            return NumberUtils.normalizeNumberToString(this.item.reach);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerOverviewPostContentComponent.prototype, "impact", {
        get: function () {
            if (this.item.isStory && !this.item.completed) {
                return '- %';
            }
            return Math.round(this.item.impact).toFixed(0) + '%';
        },
        enumerable: true,
        configurable: true
    });
    InfluencerOverviewPostContentComponent.prototype.gotoPost = function (e) {
        return this.router.navigate(["dashboard/post/" + this.item.urlHash]);
    };
    InfluencerOverviewPostContentComponent.prototype.onClose = function () {
        this.closePopupCardHover.emit();
    };
    InfluencerOverviewPostContentComponent.prototype.onLoadedImage = function () {
        var postImageContainer = this.postImage.nativeElement.parentElement;
        postImageContainer.classList.add('is-loaded');
    };
    InfluencerOverviewPostContentComponent.prototype.onImageError = function () {
        this.postImage.nativeElement.src = 'assets/images/No_Image.png';
    };
    return InfluencerOverviewPostContentComponent;
}());
export { InfluencerOverviewPostContentComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/influencer-overview-post-content/influencer-overview-post-content.component.ts.pre-build-optimizer.js